import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Row, Breadcrumb, Button } from 'antd';
import { Link } from 'react-router-dom';
import get from 'lodash/get';

import { permissionService } from 'shared/services';
import Table from 'components/Table';
import { FILTER_TYPE, paginationParam } from 'shared/constant';
import NewFilter from 'components/NewFilter';

import urlUtil from 'shared/utils/UrlUtil';
import allBillersRoute from '../../route';
import text from './ServiceList.page.translation';

import './ServiceList.style.less';

const { checkPermission } = permissionService;

class ServiceList extends Component {
  constructor(props) {
    super(props);
    const { resetFilter, match } = this.props;
    if (!match.params.page) {
      resetFilter();
    }
  }

  componentDidMount() {
    const { match, filterValue } = this.props;
    if (match.params.page) {
      this.updateServiceTable(filterValue);
    } else {
      this.updateServiceTable([]);
    }
  }

  componentDidUpdate(prevProps) {
    const { formControlShow, match, filterValue } = this.props;

    if (prevProps.match.params.page !== match.params.page) {
      this.updateServiceTable(filterValue);
    }

    if (prevProps.filterValue !== filterValue && !formControlShow) {
      if (
        !(
          prevProps.filterValue.length > 0 &&
          prevProps.filterValue.length > filterValue.length &&
          prevProps.filterValue[prevProps.filterValue.length - 1].inputValue
            .length === 0
        )
      ) {
        if (
          prevProps.match.params.page !== match.params.page ||
          (prevProps.match.params.page === match.params.page &&
            match.params.page > 1)
        ) {
          this.handleChangePage(1);
        } else {
          this.updateServiceTable(filterValue);
        }
      }
    }
  }

  updateServiceTable = filterValue => {
    const { getListService, serviceFilter, match, history } = this.props;

    let paginationValue = { ...paginationParam };
    let paramUrl = '';
    const page = get(match, 'params.page', '');
    const pageInt = parseInt(page, 10) || '';

    if (filterValue.length > 0) {
      paramUrl = this.buildGetParamUrl(filterValue);
    }

    if (page) {
      if (pageInt && pageInt >= 1) {
        paginationValue = {
          ...serviceFilter,
          page_num: pageInt,
        };
        const paginationUrl = this.buildPaginationUrl(paginationValue);
        getListService(paginationUrl, paramUrl);
      } else {
        history.push(allBillersRoute.SERVICES);
      }
    } else {
      const paginationUrl = this.buildPaginationUrl(paginationValue);
      getListService(paginationUrl, paramUrl);
    }
  };

  renderNoColumn = (t, r, index) => {
    let modifyIndex;
    const adjustIndex = index + 1;
    const { serviceFilter } = this.props;
    if (serviceFilter.page_num === 1) {
      modifyIndex = adjustIndex;
    } else {
      modifyIndex = adjustIndex + (serviceFilter.page_num - 1) * 10;
    }
    return modifyIndex;
  };

  renderServiceName = (name, record) => {
    const link = allBillersRoute.SERVICES_DETAIL.replace(':id', record.id);
    return <Link to={link}>{name}</Link>;
  };

  renderIconService = iconUrl => (
    <img src={iconUrl} alt={iconUrl} className="icon-service" />
  );

  renderStatus = (_status, record) => {
    const {
      intl: { formatMessage },
    } = this.props;
    if (record.is_active) {
      return (
        <span className="status-text active">
          {formatMessage(text.status.active)}
        </span>
      );
    }

    return (
      <span className="status-text inactive">
        {formatMessage(text.status.inactive)}
      </span>
    );
  };

  renderColumns() {
    const {
      intl: { formatMessage },
    } = this.props;
    return [
      {
        title: formatMessage(text.table.labelNo),
        key: 'index',
        render: this.renderNoColumn,
      },
      {
        title: formatMessage(text.table.serviceName),
        key: 'name',
        dataIndex: 'name',
        render: this.renderServiceName,
      },
      {
        title: formatMessage(text.table.publicServiceName),
        key: 'public_name',
        dataIndex: 'public_name',
      },
      {
        title: formatMessage(text.table.serviceId),
        key: 'public_id',
        dataIndex: 'public_id',
      },
      {
        title: formatMessage(text.table.icon),
        key: 'icon_abs_url',
        dataIndex: 'icon_abs_url',
        align: 'center',
        render: this.renderIconService,
      },
      {
        title: formatMessage(text.table.category),
        key: 'category',
        dataIndex: 'category',
      },
      {
        title: formatMessage(text.table.aggregator),
        key: 'aggregator_name',
        dataIndex: 'aggregator_name',
        render: () => 'DANA X2X',
      },
      {
        title: formatMessage(text.table.status),
        key: 'status',
        dataIndex: 'status',
        render: this.renderStatus,
      },
    ];
  }

  renderBreadCrumb = () => {
    const {
      intl: { formatMessage },
    } = this.props;
    return (
      <Row className="breadcrumb-wrapper">
        <Breadcrumb>
          <Breadcrumb.Item>
            <Link to="/">{formatMessage(text.home)}</Link>
          </Breadcrumb.Item>
          <Breadcrumb.Item>{formatMessage(text.serviceTitle)}</Breadcrumb.Item>
        </Breadcrumb>
      </Row>
    );
  };

  getRowId = row => row.id;

  buildGetParamUrl = filterValue => {
    let result = '';

    filterValue.forEach(element => {
      const value = element.inputValue[0];
      switch (element.key) {
        default:
          result += `&${element.key}=${value}`;
          break;
      }
    });

    return result;
  };

  buildPaginationUrl = serviceFilter => {
    let result = '';
    result += `page_size=${encodeURIComponent(serviceFilter.page_size)}`;
    result += `&page_count=${encodeURIComponent(serviceFilter.page_count)}`;
    result += `&page_num=${encodeURIComponent(serviceFilter.page_num)}`;

    return result;
  };

  handleChangePage = page => {
    urlUtil.changePageParams(
      allBillersRoute.SERVICES,
      page,
      this.props.history,
    );
  };

  render() {
    const {
      intl: { formatMessage },
      listService,
      serviceFilter,
      loading,
    } = this.props;
    const totalItem = serviceFilter.page_size * serviceFilter.page_count;

    const options = [
      {
        label: formatMessage(text.filter.label.serviceID),
        value: 'public_id',
        type: FILTER_TYPE.TEXT,
      },
      {
        label: formatMessage(text.filter.label.serviceName),
        value: 'name',
        type: FILTER_TYPE.TEXT,
      },
      {
        label: formatMessage(text.filter.label.category),
        value: 'category',
        type: FILTER_TYPE.TEXT,
      },
      {
        label: formatMessage(text.filter.label.status),
        value: 'status',
        type: FILTER_TYPE.RADIO,
        options: [
          { label: formatMessage(text.status.active), value: 'active' },
          { label: formatMessage(text.status.inactive), value: 'inactive' },
        ],
      },
      {
        label: formatMessage(text.filter.label.archive),
        value: 'is_archived',
        type: FILTER_TYPE.BOOL,
      },
    ];

    return (
      <div className="main-content">
        {this.renderBreadCrumb()}
        <div className="white-box-wrapper">
          <span className="title mbottom30">
            {formatMessage(text.serviceTitle)}
          </span>
          {checkPermission('Service:create', true) && (
            <Button
              className="btn new-service-btn"
              type="primary"
              size="large"
              block
            >
              <Link to={allBillersRoute.SERVICES_CREATE}>
                {formatMessage(text.createTitle)}
              </Link>
            </Button>
          )}
          <NewFilter options={options} />
          <div className="table-wrapper">
            <Table
              columns={this.renderColumns()}
              bordered
              rowID={this.getRowId}
              dataSource={listService}
              pagination="true"
              rowClass="striped-table"
              loadingValue={loading}
              currentPage={serviceFilter.page_num}
              totalItem={totalItem}
              changePage={this.handleChangePage}
            />
          </div>
        </div>
      </div>
    );
  }
}

ServiceList.propTypes = {
  listService: PropTypes.array,
  getListService: PropTypes.func,
  serviceFilter: PropTypes.object,
  intl: PropTypes.object,
  loading: PropTypes.bool,
  resetFilter: PropTypes.func,
  filterValue: PropTypes.array,
  history: PropTypes.object,
  match: PropTypes.object,
  formControlShow: PropTypes.bool,
};

export default ServiceList;
